const domain = /:\/\/([^\\/]+)/.exec(window.location.href)[1];
export default domain.includes("watch.showandtell.film");
